module.exports = __webpack_public_path__ + "static/media/Alba soffa 2,5-sits öppet avslut tyg Aragon light grey miljö modeller 2024 fyrkant.9794f32f.jpg";